import React from "react";
import "./sharedText.scss";
import StyledLink from "../StyledLink/StyledLink";

const SharedText = (props) => {
  return (
    <div className="sharedText">
      {props.blue ? (
        <div className="row">
          <hr />
          <p className="blue">{props.blue}</p>
          <hr />
        </div>
      ) : null}
      {props.logo ? <div className="logo">{props.logo}</div> : null}
      <h1>
        {props.title1}
        {props.title2 ? props.title2 : null}
      </h1>
      <p className="text1">{props.text1}</p>
      {props.text2 ? <p>{props.text2}</p> : null}
      {props.link2Name ? (
        <StyledLink
          to={props.lin2kTo}
          styles={props.link2Styles}
          linkName={props.link2Name}
          rightIcon={props.link2RightIcon}
        />
      ) : null}
      {props.linkName ? (
        <StyledLink
          to={props.linkTo}
          styles={props.linkStyles}
          linkName={props.linkName}
          leftIcon={props.leftIcon}
          rightIcon={props.rightIcon}
          rightIconColor={props.rightIconColor}
          leftIconColor={props.leftIconColor}
          rightIconSize={props.rightIconSize}
          leftIconSize={props.leftIconSize}
          linkColor={props.linkColor}
        />
      ) : null}
    </div>
  );
};

export default SharedText;
